export default __webpack_public_path__ + "static/media/sticky.bcd7a576.svg";